import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  slice as appLoadingSlice,
  reducer as appLoadingReducer,
} from 'src/app/app-loading/app-loading-reducer';
import {
  slice as subscriptionSlice,
  subscriptionReducer,
} from 'src/app/subscription/subscription-reducer';
import { blogItemReducer } from 'src/blog-item/state/blog-item-reducer';
import { blogReducer } from 'src/blog/state/blog-reducer';
import { checkoutReducer } from 'src/checkout/state/checkout-reducer';
import { meReducer } from 'src/common/state/me/me-reducer';
import { assignLabelsReducer } from 'src/dashboard/state/assign-labels/assign-labels-reducer';
import { collectionsReducer } from 'src/dashboard/state/collection/collection-reducer';
import { labelsReducer } from 'src/dashboard/state/labels/labels-reducer';
import { replaceVideoReducer } from 'src/dashboard/state/replace-video/replace-video-reducer';
import { suggestionsReducer } from 'src/dashboard/state/suggestions/suggestions-reducer';
import { upgradeReducer } from 'src/dashboard/state/upgrade/upgrade-reducer';
import { upsellReducer } from 'src/dashboard/state/upsell/upsell-reducer';
import { videoPrivacyReducer } from 'src/dashboard/state/video-privacy/video-privacy-reducer';
import { videosReducer } from 'src/dashboard/state/videos/videos-reducer';
import { landingReducer } from 'src/landing-new/state/landing-reducer';
import { pricingReducer } from 'src/pricing/state/pricing-reducer';
import { settingsReducer } from 'src/settings/state/settings-reducer';

import app from './app';
import checkout from './checkout';
import clipper from './clipper';
import stats from './stats';
import tools from './tools';
import video from './video';

const persistedLabelsReducer = persistReducer(
  {
    whitelist: ['isSidebarOpenDesktop', 'isSidebarOpenMobile'],
    storage,
    key: 'labels',
  },
  labelsReducer
);

const persistedSuggestionsReducer = persistReducer(
  {
    whitelist: ['suggestions'],
    storage,
    key: 'suggestions',
  },
  suggestionsReducer
);

const rootReducer = combineReducers({
  [appLoadingSlice]: appLoadingReducer,
  app,
  assignLabels: assignLabelsReducer,
  blog: blogReducer,
  blogItem: blogItemReducer,
  checkout, // TODO(nbermudezs): move this reducer into checkoutReducer
  checkoutReducer,
  clipper,
  collections: collectionsReducer,
  labels: persistedLabelsReducer,
  landing: landingReducer,
  me: meReducer,
  pricing: pricingReducer,
  settings: settingsReducer,
  replaceVideo: replaceVideoReducer,
  stats,
  [subscriptionSlice]: subscriptionReducer,
  suggestions: persistedSuggestionsReducer,
  tools,
  upgrade: upgradeReducer,
  upsell: upsellReducer,
  video,
  videoPrivacy: videoPrivacyReducer,
  videos: videosReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
